export default `
mutation AssignCompareListToCustomer($uid: ID!) {
  assignCompareListToCustomer(
    uid: $uid
  ) {
    result
    compare_list {
      uid
      item_count
      attributes {
        code
        label
      }
      items {
        uid
        product {
          sku
          name
          description {
            html
          }
        }
      }
    }
  }
}
`;
